<template>
  <layout class="bg-gray-100" v-statusbar:#F7FAFC>
    <box-title-l class="relative px-4">
      <div class="absolute top-0 h-full w-12" style="margin: 0;left: -1rem">
        <back-button
          class="absolute text-nav-light"
          style="left: 50%; top:50%;transform:translate(-50%, -50%)"
        />
      </div>
      {{ $t("views.user.settings.title") }}
    </box-title-l>
    <box-title-sub-s>{{
      $t("views.user.settings.notifications.title")
    }}</box-title-sub-s>
    <box-logo />
    <content-scroll-container>
      <content-scroll-inner
        class="font-bold text-chplus-regular mx-2 mt-2 flex flex-col gap-8"
      >
        <div
          v-for="notificationType in NOTIFICATION_TYPES"
          :key="notificationType"
          class="flex flex-row justify-between items-center"
        >
          <p class="flex-shrink break-words overflow-x-hidden text-left">
            {{ $t(`views.user.settings.notifications.${notificationType}`) }}
          </p>
          <linear-check-box
            :checked="isNotificationEnabled(notificationType)"
            @change="
              setNotificationEnabled({
                notificationType,
                enabled: !isNotificationEnabled(notificationType)
              })
            "
          />
        </div>
      </content-scroll-inner>
    </content-scroll-container>
  </layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Layout from "@/components/layouts/LayoutBase";
import BoxTitleL from "@/components/layouts/BoxTitleL";
import BoxTitleSubS from "@/components/layouts/BoxTitleSubS";
import BoxLogo from "@/components/layouts/BoxLogo";
import ContentScrollContainer from "@/components/layouts/ContentScrollContainer";
import ContentScrollInner from "@/components/layouts/ContentScrollInner";
import BackButton from "@/components/buttons/BackButton";
import LinearCheckBox from "@/components/inputs/LinearCheckBox";
import StatusBarDirective from "@/directives/StatusBarDirective";

import { NOTIFICATION_TYPES } from "@/store/modules/notifications";

export default {
  name: "Notifications",
  directives: {
    statusbar: StatusBarDirective
  },
  components: {
    BackButton,
    ContentScrollInner,
    ContentScrollContainer,
    Layout,
    BoxTitleL,
    BoxTitleSubS,
    BoxLogo,
    LinearCheckBox
  },
  data() {
    return {
      NOTIFICATION_TYPES
    };
  },
  computed: {
    ...mapGetters("notifications", ["isNotificationEnabled"])
  },
  methods: {
    ...mapActions("notifications", ["setNotificationEnabled"])
  }
};
</script>
